import React from 'react';
import { AlertTriangle, RefreshCw, X } from 'lucide-react';
import { useAuthStatus } from '../hooks/useAuthStatus';

export const AuthWarningBanner: React.FC = () => {
  const { isAuthenticated, error, message, triggerAuth, isStandalone } = useAuthStatus();
  const [dismissed, setDismissed] = React.useState(false);

  // Only show if not authenticated and has auth error
  if (isAuthenticated || error !== 'auth' || dismissed) {
    return null;
  }

  return (
    <div className="bg-warning/20 border-b-2 border-warning/50 px-4 py-3 flex items-center justify-between gap-4 sticky top-0 z-50 shadow-lg">
      <div className="flex items-center gap-3 flex-1 min-w-0">
        <AlertTriangle className="w-5 h-5 text-warning flex-shrink-0" />
        <div className="flex-1 min-w-0">
          <div className="font-bold text-warning text-sm uppercase tracking-wider">
            Not Authenticated
          </div>
          <div className="text-xs text-sub mt-0.5">
            {isStandalone 
              ? 'Changes are only saved locally. Sign in to sync across devices.'
              : 'Changes are only saved locally. Sign in to sync to cloud.'}
          </div>
        </div>
      </div>
      
      <div className="flex items-center gap-2 flex-shrink-0">
        <button
          onClick={triggerAuth}
          className="px-4 py-1.5 bg-warning/20 hover:bg-warning/30 border border-warning/50 rounded text-warning text-sm font-bold uppercase tracking-wider transition-colors flex items-center gap-2"
        >
          <RefreshCw className="w-4 h-4" />
          Authenticate Now
        </button>
        <button
          onClick={() => setDismissed(true)}
          className="p-1 hover:bg-warning/20 rounded text-warning/70 hover:text-warning transition-colors"
          aria-label="Dismiss warning"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

